import { render, staticRenderFns } from "./addShift.vue?vue&type=template&id=6e7897ff&"
import script from "./addShift.vue?vue&type=script&setup=true&lang=js&"
export * from "./addShift.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./addShift.vue?vue&type=style&index=0&id=6e7897ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports